import styled from "styled-components"

export const StyledCard = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0 8px 16px ${(props) => props.theme.colors.darkGrey05};
  padding: ${(props) => props.padding}px;
  background-image: url(${(props) => (props.bgImage ? props.bgImage : "")});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
    ${(props) => props.bgImage && `min-height: 300px;`}
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 24px 16px;
    ${(props) => props.bgImage && `min-height: 200px;`}
  }
`
